module.exports = __webpack_public_path__ + "static/media/demo-unit.327b2fa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/demo-unit.png
// module id = 1754
// module chunks = 0